export const settings = {
    sortable: true,
    pagination: false,
    scrollY: false,
    scrollX: true,
    rowsPerPage: 20,
    columnFilter: true,
    css: true,
    labels: {
        search: 'Search...',    // search input placeholer
        filter: 'Filter',       // filter inputs placeholder
        noRows: 'No entries found',
        info: 'Showing {start} to {end} of {rows} entries',
        previous: 'Previous',
        next: 'Next',       
    },
    blocks: {
        searchInput: true, 
        paginationButtons: false,
        paginationRowCount: false,
    }
  }